<template>
  <div class="w-full">
    <div class="nav flex flex-row justify-between items-center py-3 px-4 w-full">
      <div class="flex lg:space-x-6 space-x-3 items-center">
        <img class="lg:ml-2 h-10 hidden lg:flex lg:w-auto w-24" src="https://res.cloudinary.com/dcsensx8u/image/upload/v1644320869/Hotspot_logo_5.png" alt="wificomlogo">
        <div class="relative flex items-center border border-gray-200 focus-within:border-express rounded-lg sm:w-96 w-56 bg-gray-50 transition-colors">
          <input
              class="border-0 bg-transparent rounded-lg w-full pl-4 pr-10 py-2 text-sm focus:outline-none"
              type="text"
              placeholder="Search Retailer, Personnel"
              v-model.trim="searchvalue">

          <button class="absolute right-3" @click="navigate(`/search/${searchvalue}`)">
           <svg class="sm:w-5 sm:h-5 w-4 h-4 text-expressgray cursor-pointer hover:text-express" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"></path></svg>
          </button>
        </div>
      </div>

      <div class="flex items-center cursor-pointer">
        <a v-if="user.primaryaccount==='super_administrator'" href="https://legacy.tizeti.com/hotspot/download_retailers.php"
           class="hidden lg:flex items-center space-x-2 text-sm font-medium text-express hover:text-expressbutton border border-express rounded-lg px-4 py-2 transition-colors">
          <i class="fas fa-download text-xs"></i>
          <span>Download Retailers</span>
        </a>
      </div>
    </div>
  </div>

</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "AuthHeaders.vue",
  created() {
    console.log('user',this.user)
  },
  data(){
    return {
      darkmode:false,
      searchvalue: ''
    }
  },
  computed:{
    ...mapGetters({
      user :'authentication/getUser',
    })
  },
  methods:{
    toggle:(value)=>{
      console.log("Parent Component received event ", value)
  },
   navigate:  function(url){
     // url = `${url}?${this.searchvalue}`
    // console.log('url',url)
      this.$store.dispatch('admins/action_search_personnel',{
       search_value: this.searchvalue,
       toast:this.$toast,
       router:this.$router
     });



     this.$router.push({path: url, query: { search_value: this.search_value}})
      // this.$router.push(url)
    }
  }
}
</script>

<style scoped>

.inset-center {
  position: absolute;
  top: 50%;
  right: 1%;
  transform: translate(-50%, -50%);
}

</style>
